// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { RoleResourceConstraint, RoleResourceConstraintResponse } from "../schema";
import { serialize_RoleResourceConstraint_internal, deserialize_RoleResourceConstraint_internal } from "./RoleResourceConstraint";

export function serialize_RoleResourceConstraintResponse_internal(value: RoleResourceConstraintResponse): unknown {
  return ((value: { body: RoleResourceConstraint[] }): unknown => {
    return {
      body: ((value: RoleResourceConstraint[]): unknown => {
        return value.map((value: RoleResourceConstraint): unknown => {
          return serialize_RoleResourceConstraint_internal(value);
        });
      })(value["body"]),
    };
  })(value);
}
export function serialize_RoleResourceConstraintResponse(obj: RoleResourceConstraintResponse): string {
  return renderJsonWithNumbersAsBigint(serialize_RoleResourceConstraintResponse_internal(obj));
}
export function deserialize_RoleResourceConstraintResponse_internal(value: unknown): ParserResult<RoleResourceConstraintResponse> {
  return ((
    value: unknown,
  ): ParserResult<{
    body: RoleResourceConstraint[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/RoleResourceConstraintResponse]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/RoleResourceConstraintResponse]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "body")) {
      return { success: false, reason: `[#/components/schemas/RoleResourceConstraintResponse/body]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'body'.` };
    }
    const parsed_body = ((): ParserResult<RoleResourceConstraint[]> => {
      return ((value: unknown): ParserResult<RoleResourceConstraint[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/RoleResourceConstraintResponse/body]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<RoleResourceConstraint> => {
          return deserialize_RoleResourceConstraint_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/RoleResourceConstraintResponse/body]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["body"]);
    })();
    if (!parsed_body.success) {
      return { success: false, reason: parsed_body.reason };
    }
    return { success: true, value: { body: parsed_body.value } };
  })(value);
}
export function deserialize_RoleResourceConstraintResponse(str: string): ParserResult<RoleResourceConstraintResponse> {
  return deserialize_RoleResourceConstraintResponse_internal(parseJsonWithNumbersAsBigint(str));
}
